import React from 'react';
import { TermsOfService } from './LegalContent';

function TermsPage() {
  return (
    <div className="support-page">
      <TermsOfService />
    </div>
  );
}

export default TermsPage;
